'use client';
import { projectName } from '../../../packages/plugin-shared/projectChoice.mjs';
import { FolderGit2 } from 'lucide-react';
import type { ProjectFilterPillsProps } from 'elowen-plugin-ui-kit';
import { useProjects } from '../../lib/queries';
import { useTranslation } from '../../lib/i18n';
import { ProjectIcon } from './ProjectIcon';
import { RowPicker, type RowPickerItem } from './RowPicker';

/** Project catalog adapter for the canonical anchored single-choice surface.
 *  The caller owns selection and persistence; fewer than two projects need no filter. */
export function ProjectFilterPills({ value, onChange, includeAll = true }: ProjectFilterPillsProps) {
  const { data: projects } = useProjects();
  const { t } = useTranslation();
  if (!projects || projects.length < 2) return null;

  const selected = value === 'all' ? undefined : projects.find((project) => project.id === value);
  const items: RowPickerItem[] = [
    ...(includeAll ? [{ id: 'all', label: t.common.filterAllProjects, group: '', icon: <FolderGit2 size={14} aria-hidden /> }] : []),
    ...projects.map((project) => ({
      id: String(project.id),
      label: projectName(project),
      group: '',
      icon: <ProjectIcon project={project} size={14} />,
    })),
  ];
  return <RowPicker
    label={t.common.filterProjectsAria}
    summary={selected ? projectName(selected) : t.common.filterAllProjects}
    icon={selected ? <ProjectIcon project={selected} size={14} /> : <FolderGit2 size={14} aria-hidden />}
    items={items}
    value={String(value)}
    onChange={(next) => onChange(next === 'all' ? 'all' : Number(next))}
    className="w-auto max-w-full"
  />;
}
